__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ewmhost";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@assetmark/ewm30-routing-shell", "1.3.1", function() { return Promise.all([__webpack_require__.e(577), __webpack_require__.e(5), __webpack_require__.e(599)]).then(function() { return function() { return __webpack_require__(2577); }; }); });
			register("@assetmark/ewm30-routing-shell", "1.6.0", function() { return Promise.all([__webpack_require__.e(899), __webpack_require__.e(5), __webpack_require__.e(599)]).then(function() { return function() { return __webpack_require__(899); }; }); });
			register("@assetmark/ui-components", "26.14.31", function() { return Promise.all([__webpack_require__.e(102), __webpack_require__.e(5), __webpack_require__.e(94), __webpack_require__.e(775)]).then(function() { return function() { return __webpack_require__(4102); }; }); });
			register("@microsoft/applicationinsights-core-js", "3.4.5", function() { return Promise.all([__webpack_require__.e(716), __webpack_require__.e(862), __webpack_require__.e(162)]).then(function() { return function() { return __webpack_require__(162); }; }); });
			register("@microsoft/applicationinsights-react-js", "18.3.6", function() { return Promise.all([__webpack_require__.e(716), __webpack_require__.e(5), __webpack_require__.e(970), __webpack_require__.e(147)]).then(function() { return function() { return __webpack_require__(3147); }; }); });
			register("@microsoft/applicationinsights-web", "3.4.5", function() { return Promise.all([__webpack_require__.e(716), __webpack_require__.e(862), __webpack_require__.e(383), __webpack_require__.e(970)]).then(function() { return function() { return __webpack_require__(4383); }; }); });
			register("@tanstack/react-query", "4.24.10", function() { return Promise.all([__webpack_require__.e(621), __webpack_require__.e(5)]).then(function() { return function() { return __webpack_require__(4621); }; }); });
			register("classnames", "2.5.1", function() { return __webpack_require__.e(184).then(function() { return function() { return __webpack_require__(4184); }; }); });
			register("jwt-decode", "3.1.2", function() { return function() { return __webpack_require__(6245); }; }, 1);
			register("oidc-client-ts", "2.4.1", function() { return Promise.all([__webpack_require__.e(406), __webpack_require__.e(461)]).then(function() { return function() { return __webpack_require__(2406); }; }); });
			register("react-error-boundary", "4.1.2", function() { return Promise.all([__webpack_require__.e(5), __webpack_require__.e(511)]).then(function() { return function() { return __webpack_require__(4511); }; }); });
			register("react-oidc-context", "^2.3.0", function() { return Promise.all([__webpack_require__.e(5), __webpack_require__.e(23), __webpack_require__.e(101)]).then(function() { return function() { return __webpack_require__(101); }; }); });
			register("web-vitals", "2.1.4", function() { return __webpack_require__.e(131).then(function() { return function() { return __webpack_require__(2131); }; }); });
			initExternal(9045);
			initExternal(1215);
			initExternal(6677);
			initExternal(4843);
			initExternal(2382);
			initExternal(9898);
			initExternal(6252);
			initExternal(1271);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};